import styled, {css} from 'styled-components'

export const StyledPrivateLayout = styled.div(
    ({theme: {palette}}) => css`
        background-color: ${palette.neutral[50]};
        display: grid;
        grid-template-columns: auto minmax(0, 1fr);
        height: 100%;
        overflow: hidden;
    `
)
